import { createContext, useContext, useState, ReactNode } from "react";

export interface CustomSection {
  id: string;
  text: string;
  editing: boolean;
}

export interface Value {
  id: number;
  name: string;
  description: string;
  adherence: number;
  status: string;
  gradient: string;
  icon: ReactNode;
}

export interface Competency {
  id: number;
  name: string;
  description: string;
  level?: string;
}

export interface CompetencyCategory {
  title: string;
  level: string;
  skills: Array<{
    name: string;
    description: string;
    date: string;
    proficiencyLevel: string;
    icon: ReactNode;
  }>;
}

export interface HandoutData {
  name: string;
  role: string;
  competencyProfile: string;
  evaluationDate: string;
  photo: string;
  performance: string;
  valuesAdherence: number;
  values: Value[];
  masteredCompetencies: Competency[];
  growingCompetencies: Competency[];
  competencyCategories: CompetencyCategory[];
  customSections: { [key: string]: CustomSection };
}

interface HandoutContextType {
  handoutData: HandoutData | null;
  setHandoutData: (data: HandoutData) => void;
}

const HandoutContext = createContext<HandoutContextType | null>(null);

export function HandoutProvider({ children }: { children: ReactNode }) {
  const [handoutData, setHandoutData] = useState<HandoutData | null>(null);

  return (
    <HandoutContext.Provider value={{ handoutData, setHandoutData }}>
      {children}
    </HandoutContext.Provider>
  );
}

export function useHandout() {
  const context = useContext(HandoutContext);
  if (context === null) {
    throw new Error("useHandout must be used within HandoutProvider");
  }
  return context;
}
